import customFormatters from '@/filters/customFormatters'

export default {
  name: 'ExploreWidget',
  mixins: [customFormatters],
  components: {
    ExploreWidgetCategoryMultiple: () => import(/* webpackChunkName: "ExploreWidgetCategoryMultiple" */'@/views/explore/explore-widget-category-multiple/ExploreWidgetCategoryMultiple.vue'),
    ExploreWidgetCategorySimple: () => import(/* webpackChunkName: "ExploreWidgetCategorySimple" */'@/views/explore/explore-widget-category-simple/ExploreWidgetCategorySimple.vue')
  },
  props: {
    widget: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
